import { CoreFeatures } from '../CoreFeatures';
import { MonitoringErrorHandler } from 'monitoring-error-handler';
import { appInsightsInstrumentationKey, appInsightsCloudComponentName } from 'app.constants';
export class MonitoringInitializers {
    static async init() {
        const isApplicationInsightsEnabled = CoreFeatures.applicationInsightsLogEnabled();
        MonitoringErrorHandler.instance.initialize({
            [isApplicationInsightsEnabled ? 'applicationInsights' : '']: {
                instrumentationKey: appInsightsInstrumentationKey,
                applicationName: appInsightsCloudComponentName,
            },
        });
    }
}
